import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import lodash from 'lodash';
import deepdash from 'deepdash';
const _ = deepdash(lodash);

import { commonStore } from "./commonStore";
import { authorizationStore } from "./authorizationStore";
import { classificationStore } from "./classificationStore";
import { store as canvasDesignStore } from "./canvasDesignStore";
import commons from "../commons/commons";

export const clientStore = new Vuex.Store({
  state: {
    ...commonStore.state,
    workspace: {},
    workspaceModules: [],
    workspaceContext: null,
    module: {},
    moduleImport: {},
    list: {},
    basket: [],
    phoneNumberData: {
      code: 'MY',
      dialCode: '+60'
    }
  },
  mutations: {
    ...commonStore.mutations,
    setWorkspace(state, data) {
      $cookies.set('wsId', data.id);
      state.client.defaults.headers['wsId'] = data.id;
      state.workspace = data;
      state.workspaceModules = data.vectors;
      // set profile
      authorizationStore.dispatch('setUserProfile', data.profile);
      // set workspace
      classificationStore.dispatch("setWorkspace", data.name);
      // set users
      classificationStore.dispatch('setUsers', {users: data.users});
      canvasDesignStore.dispatch('setUsers', data.users);
    },
    setModule(state, data) {
      state.module = data;
    },
    setList(state, data) {
      state.list = data;
    },
    setWorkspaceContext(state, data) {
      $cookies.set('wsContext', data);
      state.workspaceContext = data;
    },
    setPhoneNumberData(state, data) {
      state.phoneNumberData = data;
    }
  },
  actions: {
    ...commonStore.actions,
    // workspace
    async loadWorkspace({ state, commit, dispatch }, payload) {
      let workspaceId = payload.id || $cookies.get('wsId');

      if (!workspaceId) {
        let res = await dispatch('getWorkspaces', { search: '' })
        if (Array.isArray(res) && res[0] && res[0].id) workspaceId = res[0].id
      }

      try {
        let res = await state.client.get(`/api/Workspace/${workspaceId}`);
        authorizationStore.dispatch('setRoles', res.data.roles);
        commons.expandMenu(res.data.menus, res.data.vectors)
        commit('setWorkspace', res.data)
        // workspace context
        if (res.data && res.data.hasContext) {
          const context = $cookies.get('wsContext')
          if (context)
            commit('setWorkspaceContext', context)
        }
      } catch (err) {
        if ($cookies.get('wsId')) {
          $cookies.remove('wsId');
        }
        throw err
      }
    },
    async loadDiagram({ state }, payload) {
      return await state.client.get(`/api/Workspace/Diagram/${commons.decodeids(payload)}`);
    },
    async loadDocumentInputs({ state }, payload) {
      return await state.client.get(`/api/Activity/DocumentInputs?moduleId=${payload.moduleId}&templateId=${payload.tempalteId}`);
    },
    //from listview, todo: to be refactor
    async loadWorkspaceModule({ state, commit }, payload) {
      const moduleId = commons.decodeids(payload.moduleId)
      try {
        // workspace
        if (_.isEmpty(state.workspace) || !state.workspaceModules.find(x => x.id == moduleId)) {
          let res = await state.client.get(`/api/Workspace/0?vector=${moduleId}`);
          authorizationStore.dispatch('setRoles', res.data.roles);
          commons.expandMenu(res.data.menus, res.data.vectors)
          commit('setWorkspace', res.data)
        }
        // module
        let module = state.workspaceModules.find(x => x.id == moduleId)
        if (module)
          commit('setModule', module)
        // list
        if (payload.listId) {
          let list = _.findDeep(state.workspace.menus, x => (x.id == payload.listId), {
            childrenPath: 'children'
          })
          if (list && list.value && list.parent && list.parent.id && list.parent.type != 'group') {
            commit('setList', {
              id: list.value.id,
              name: list.value.name,
              emoji: list.value.emoji,
              parentId: list.parent.id
            })
          } else {
            commit('setList', {})
          }
        } else {
          commit('setList', {})
        }
        // expand sidebar menu
        if ((state.list && state.list.parentId) || state.module && state.module.id) {
          let workspaceMenus = _.cloneDeep(state.workspace.menus)
          commons.expandSidebarMenu(
            state.module.id ? state.module.id : state.list.parentId,
            workspaceMenus
          )
          state.workspace.menus = workspaceMenus;
        }
      } catch (err) {
        throw err
      }
    },
    async getWorkspaces({ state }, payload) {
      try {
        let res = await state.client.get(`/api/Workspace?search=${payload.search}`)
        return res.data || []
      } catch (err) {
        console.error(err)
        return []
      }
    },
    async loadDocumentForm(context, payload) {
      let res = await context.state.client.post(`/api/Activity/Form`, payload);
      return res;
    },
    async sendInvitation({ state }, payload) {
      try {
        return await state.client.post(`/api/workspace/invites`, payload);
      } catch (err) {
        throw err
      }
    },
    async getInvitationLink({ state }, payload) {
      try {
        let res = await state.client.post(`/api/workspace/invites`, payload);
        return res.data
      } catch (err) {
        console.error(err)
      }
    },
    // workspace context
    setWorkspaceContext({ commit }, payload) {
      commit('setWorkspaceContext', payload)
    },
    async getWorkspaceContexts({ state, getters }, payload) {
      try {
        let res = await state.client.get(`/api/Workspace/Context?id=${getters.workspaceId}&search=${payload.search}`)
        return res.data || []
      } catch (err) {
        console.error(err)
        return []
      }
    },
    // list view
    async loadWorkspaceList({ state, commit }, payload) {
      let res = await state.client.post('/api/Workspace/List', payload);
      return res;
    },
    async retrieveDashboard({ state }, payload) {
      return await state.client.get(`/api/Workspace/Dashboard?activityEveryone=${payload.activityEveryone}`);
    },
    // notification
    async retrieveNotification({ state }, payload) {
      return await state.client.post('/api/Workspace/Notifications', payload);
    },
    async retrieveNotificationCount({ state }) {
      return await state.client.get('/api/Workspace/NotificationCount')
    },
    async clearNotificationUnreceivedCount({ state }) {
      return await state.client.get('/api/Workspace/ClearNotificationUnreceived')
    },
    async notificationWatch({ state }, payload) {
      return await state.client.post('/api/Workspace/Watch/', payload)
    },
    // htmlTemplate
    async htmlTemplateProcess({ state }, payload) {
      return await state.client.get(`/service/HTMLTemplateProcessing/document?documentModel=${encodeURIComponent(payload)}`)
    },
    // my calendar
    async getMyCalender({ state }, payload) {
      return await state.client.post('/api/Workspace/Calendar', payload)
    },
    async setMyCalendarEvent({ state }, payload) {
      return await state.client.post('/api/Workspace/AddToMyCalendar', payload)
    },
    // member
    async getMember({ state }, payload) {
      return await state.client.get(`/api/User/list?search=${encodeURI(payload.searchDisplayName)}`)
    },
    async updateMember({ state }, payload) {
      return await state.client.post('/api/User/UpdateDetail', payload)
    },
    async resetUserPassword({ state }, payload) {
      return await state.client.post('/api/User/ResetPassword/', payload)
    },
    async setDisableEnable({ state }, payload) {
      return await state.client.post('/api/User/DisableEnable', payload)
    },
    async unlockUser({ state }, payload) {
      return await state.client.post('/api/User/Unlock', payload)
    },
    async setRole({ state }, payload) {
      return await state.client.post('/api/User/SetRole', payload)
    },
    setPhoneNumberData({ commit }, payload) {
      commit('setPhoneNumberData', {
        code: payload.code,
        dialCode: payload.dialCode
      })
    },
    async loadHistory({ state }, payload) {
      return await state.client.get(`/api/e/history/${payload.type},${payload.id}`);
    },
  },
  getters: {
    workspaceId: state => state.workspace && state.workspace.id,
    workspaceName: state => state.workspace && state.workspace.name,
    workspaceStates: state => state.workspace && state.workspace.states,
    moduleId: state => state.module && state.module.id,
    listId: state => state.list && state.list.id,
  }
})